<div class="cadastro-fornecedor-container">
  <div class="header">
    <div>
      <h1>{{ id > 0 ? 'Editar Fornecedor' : 'Cadastrar Fornecedor' }}</h1>
      <p class="subtitle">Preencha os dados principais, contato e endereço do fornecedor.</p>
    </div>
  </div>

  <div class="card-box">
    <div class="row g-3">
      <div class="col-12 section-title">Informações principais</div>
      <div class="col-md-2">
        <label class="form-label">Código</label>
        <input type="number" class="form-control" [(ngModel)]="codigo" placeholder="Código interno" />
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="ativo" [(ngModel)]="ativo" />
          <label class="form-check-label" for="ativo">Ativo</label>
        </div>
      </div>
      <div class="col-md-8"></div>

      <div class="col-md-6">
        <label class="form-label">Nome *</label>
        <input type="text" class="form-control" [(ngModel)]="nome" placeholder="Nome do fornecedor" />
      </div>
      <div class="col-md-6">
        <label class="form-label">Razão Social</label>
        <input type="text" class="form-control" [(ngModel)]="razaoSocial" placeholder="Razão social" />
      </div>

      <div class="col-md-3">
        <label class="form-label">CNPJ</label>
        <input type="text" class="form-control" [(ngModel)]="cnpj" [textMask]="{mask: cnpjMask}" placeholder="00.000.000/0000-00" />
      </div>
      <div class="col-md-3">
        <label class="form-label">CPF</label>
        <input type="text" class="form-control" [(ngModel)]="cpf" [textMask]="{mask: cpfMask}" placeholder="000.000.000-00" />
      </div>
      <div class="col-md-3">
        <label class="form-label">CEP</label>
        <input type="text" class="form-control" [(ngModel)]="cep" [textMask]="{mask: cepMask}" placeholder="00 000-000" />
      </div>
      <div class="col-md-3">
        <label class="form-label">CID</label>
        <input type="text" class="form-control" [(ngModel)]="cidId" placeholder="Cidade" />
      </div>

      <div class="col-12 section-title mt-2">Endereço e status</div>
      <div class="col-md-4">
        <label class="form-label">Tipo Logradouro</label>
        <select class="form-control" [(ngModel)]="idTipoLogradouro">
          <option [ngValue]="null">Selecione</option>
          <option *ngFor="let item of tiposLogradouro" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Logradouro</label>
        <input type="text" class="form-control" [(ngModel)]="logradouro" placeholder="Nome da via" />
      </div>
      <div class="col-md-2">
        <label class="form-label">Número</label>
        <input type="number" class="form-control" [(ngModel)]="numero" placeholder="Nº" />
      </div>

      <div class="col-md-4">
        <label class="form-label">Bairro</label>
        <input type="text" class="form-control" [(ngModel)]="bairro" placeholder="Bairro" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Complemento</label>
        <input type="text" class="form-control" [(ngModel)]="complemento" placeholder="Complemento" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Status *</label>
        <select class="form-control" [(ngModel)]="idFinStatusFornecedor">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of statusFornecedor" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label">Plano de Contas *</label>
        <app-select-busca [opcoes]="planosContas" [(ngModel)]="idPlanoContas"></app-select-busca>
      </div>
      <div class="col-md-4"></div>

      <div class="col-12 section-title mt-2">Contato e observações</div>
      <div class="col-md-4">
        <label class="form-label">Telefone 1</label>
        <input type="text" class="form-control" [(ngModel)]="telefone1" [textMask]="{mask: telefoneMask}" placeholder="(00) 0000-0000" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Telefone 2</label>
        <input type="text" class="form-control" [(ngModel)]="telefone2" [textMask]="{mask: telefoneMask}" placeholder="(00) 0000-0000" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Insc. Estadual</label>
        <input type="text" class="form-control" [(ngModel)]="inscricaoEstadual" placeholder="Inscrição estadual" />
      </div>

      <div class="col-md-4">
        <label class="form-label">Email 1</label>
        <input type="email" class="form-control" [(ngModel)]="email1" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Email 2</label>
        <input type="email" class="form-control" [(ngModel)]="email2" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Email 3</label>
        <input type="email" class="form-control" [(ngModel)]="email3" />
      </div>

      <div class="col-md-4">
        <label class="form-label">Insc. Municipal</label>
        <input type="text" class="form-control" [(ngModel)]="inscricaoMunicipal" placeholder="Inscrição municipal" />
      </div>
      <div class="col-md-12">
        <label class="form-label">Observações</label>
        <textarea rows="3" class="form-control" [(ngModel)]="observacao" placeholder="Anotações adicionais sobre o fornecedor"></textarea>
      </div>
    </div>

    <div class="acoes mt-3">
      <button type="button" class="btn btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <button type="button" class="btn btn-success" (click)="salvar()">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </div>
</div>
